export enum PerformerCategoryEnum {
  MUSIC = 2,
  SPORTS = 3,
  COMEDYTHEATRE = 4,
}

export const DEFAULT_PAGE_SIZE = 24;
export const MUSIC_PERFORMERS_SECTION_PAGE_SIZE = 25;

export const DEFAULT_PAGE = 1;